// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2twIj","type":"styles_type__31RIx","choices":"styles_choices__XK5mT"};